import { render } from "./UserProfileIcon.vue?vue&type=template&id=f3bf5b58"
import script from "./UserProfileIcon.vue?vue&type=script&lang=js"
export * from "./UserProfileIcon.vue?vue&type=script&lang=js"

import "./UserProfileIcon.vue?vue&type=style&index=0&id=f3bf5b58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__